export default "__VITE_ASSET__C6NN3Q2$__"